/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackInstanceListRsp } from '../models/unistack-instance-list-rsp';
import { UnistackInstanceCreateRsp } from '../models/unistack-instance-create-rsp';
import { UnistackInstanceCreateReq } from '../models/unistack-instance-create-req';
import { UnistackInstanceLookupRsp } from '../models/unistack-instance-lookup-rsp';
import { UnistackInstanceUpdateRsp } from '../models/unistack-instance-update-rsp';
import { UnistackInstanceUpdateReq } from '../models/unistack-instance-update-req';
import { UnistackInstanceDeleteRsp } from '../models/unistack-instance-delete-rsp';
import { RuntimeStreamError } from '../models/runtime-stream-error';
import { UnistackChunk } from '../models/unistack-chunk';
@Injectable({
  providedIn: 'root',
})
class InstanceServiceService extends __BaseService {
  static readonly InstanceListPath = '/api/unistack/v0/instances';
  static readonly InstanceCreatePath = '/api/unistack/v0/instances';
  static readonly InstanceLookupPath = '/api/unistack/v0/instances/{uuid}';
  static readonly InstanceUpdatePath = '/api/unistack/v0/instances/{uuid}';
  static readonly InstanceDeletePath = '/api/unistack/v0/instances/{uuid}';
  static readonly InstanceConsolePath = '/api/unistack/v0/instances/{uuid}/console';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `InstanceServiceService.InstanceListParams` containing the following parameters:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `filter`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  InstanceListResponse(params: InstanceServiceService.InstanceListParams): __Observable<__StrictHttpResponse<UnistackInstanceListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    if (params.filter != null) __params = __params.set('filter', params.filter.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/instances`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackInstanceListRsp>;
      })
    );
  }
  /**
   * @param params The `InstanceServiceService.InstanceListParams` containing the following parameters:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `filter`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  InstanceList(params: InstanceServiceService.InstanceListParams): __Observable<UnistackInstanceListRsp> {
    return this.InstanceListResponse(params).pipe(
      __map(_r => _r.body as UnistackInstanceListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  InstanceCreateResponse(body: UnistackInstanceCreateReq): __Observable<__StrictHttpResponse<UnistackInstanceCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/instances`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackInstanceCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  InstanceCreate(body: UnistackInstanceCreateReq): __Observable<UnistackInstanceCreateRsp> {
    return this.InstanceCreateResponse(body).pipe(
      __map(_r => _r.body as UnistackInstanceCreateRsp)
    );
  }

  /**
   * @param params The `InstanceServiceService.InstanceLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `fields`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  InstanceLookupResponse(params: InstanceServiceService.InstanceLookupParams): __Observable<__StrictHttpResponse<UnistackInstanceLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/instances/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackInstanceLookupRsp>;
      })
    );
  }
  /**
   * @param params The `InstanceServiceService.InstanceLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `fields`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  InstanceLookup(params: InstanceServiceService.InstanceLookupParams): __Observable<UnistackInstanceLookupRsp> {
    return this.InstanceLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackInstanceLookupRsp)
    );
  }

  /**
   * @param params The `InstanceServiceService.InstanceUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  InstanceUpdateResponse(params: InstanceServiceService.InstanceUpdateParams): __Observable<__StrictHttpResponse<UnistackInstanceUpdateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/unistack/v0/instances/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackInstanceUpdateRsp>;
      })
    );
  }
  /**
   * @param params The `InstanceServiceService.InstanceUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  InstanceUpdate(params: InstanceServiceService.InstanceUpdateParams): __Observable<UnistackInstanceUpdateRsp> {
    return this.InstanceUpdateResponse(params).pipe(
      __map(_r => _r.body as UnistackInstanceUpdateRsp)
    );
  }

  /**
   * @param uuid undefined
   * @return A successful response.
   */
  InstanceDeleteResponse(uuid: string): __Observable<__StrictHttpResponse<UnistackInstanceDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/instances/${uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackInstanceDeleteRsp>;
      })
    );
  }
  /**
   * @param uuid undefined
   * @return A successful response.
   */
  InstanceDelete(uuid: string): __Observable<UnistackInstanceDeleteRsp> {
    return this.InstanceDeleteResponse(uuid).pipe(
      __map(_r => _r.body as UnistackInstanceDeleteRsp)
    );
  }

  /**
   * @param params The `InstanceServiceService.InstanceConsoleParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `type`:
   *
   * @return A successful response.(streaming responses)
   */
  InstanceConsoleResponse(params: InstanceServiceService.InstanceConsoleParams): __Observable<__StrictHttpResponse<{error?: RuntimeStreamError, result?: UnistackChunk}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.type != null) __params = __params.set('type', params.type.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/instances/${params.uuid}/console`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{error?: RuntimeStreamError, result?: UnistackChunk}>;
      })
    );
  }
  /**
   * @param params The `InstanceServiceService.InstanceConsoleParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `type`:
   *
   * @return A successful response.(streaming responses)
   */
  InstanceConsole(params: InstanceServiceService.InstanceConsoleParams): __Observable<{error?: RuntimeStreamError, result?: UnistackChunk}> {
    return this.InstanceConsoleResponse(params).pipe(
      __map(_r => _r.body as {error?: RuntimeStreamError, result?: UnistackChunk})
    );
  }
}

module InstanceServiceService {

  /**
   * Parameters for InstanceList
   */
  export interface InstanceListParams {
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    filter?: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_name' | 'field_vcpus' | 'field_disk' | 'field_memory'>;
  }

  /**
   * Parameters for InstanceLookup
   */
  export interface InstanceLookupParams {
    uuid: string;
    fields?: Array<'field_all' | 'field_id' | 'field_name' | 'field_vcpus' | 'field_disk' | 'field_memory'>;
    account?: string;
  }

  /**
   * Parameters for InstanceUpdate
   */
  export interface InstanceUpdateParams {
    uuid: string;
    body: UnistackInstanceUpdateReq;
  }

  /**
   * Parameters for InstanceConsole
   */
  export interface InstanceConsoleParams {
    uuid: string;
    type?: 'invalid' | 'vnc' | 'rfb' | 'spice' | 'term';
  }
}

export { InstanceServiceService }
